import React from "react";

const keyOf = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const buildDays = (visibleMonth) => {
  const first = new Date(
    visibleMonth.getFullYear(),
    visibleMonth.getMonth(),
    1
  );

  const mondayOffset = (first.getDay() + 6) % 7;

  const start = new Date(
    visibleMonth.getFullYear(),
    visibleMonth.getMonth(),
    1 - mondayOffset
  );

  return Array.from({ length: 42 }, (_, index) => {
    const day = new Date(start);
    day.setDate(start.getDate() + index);
    return day;
  });
};

const labelFor = (assignment) => {
  if (!assignment) return "Add work";

  if (assignment.attendance_status === "absent") return "Absent";
  if (assignment.attendance_status === "holiday") return "Holiday";
  if (assignment.attendance_status === "sick") return "Sick";

  return assignment.shift_type === "part_time"
    ? "Part time"
    : "Full time";
};

const StaffCalendar = ({
  visibleMonth,
  assignments,
  onPrevious,
  onNext,
  onToday,
  onSelectDay,
}) => {
  const today = keyOf(new Date());

  const assignmentMap = new Map(
    assignments.map((item) => [item.date, item])
  );

  const monthDays = buildDays(visibleMonth);

  return (
    <section className="staff-calendar">
      <header className="staff-calendar-head">
        <div>
          <span>Attendance calendar</span>
          <h2>
            {visibleMonth.toLocaleDateString("en-GB", {
              month: "long",
              year: "numeric",
            })}
          </h2>
        </div>

        <div className="staff-calendar-actions">
          <button type="button" onClick={onPrevious}>
            ← Previous
          </button>

          <button type="button" onClick={onToday}>
            Today
          </button>

          <button type="button" onClick={onNext}>
            Next →
          </button>
        </div>
      </header>

      <div className="staff-calendar-scroll">
        <div className="staff-calendar-grid">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((item) => (
            <div className="staff-calendar-weekday" key={item}>
              {item}
            </div>
          ))}

          {monthDays.map((date) => {
            const dateKey = keyOf(date);
            const assignment = assignmentMap.get(dateKey);
            const isCurrentMonth =
              date.getMonth() === visibleMonth.getMonth();

            return (
              <button
                type="button"
                key={dateKey}
                className={`staff-calendar-day ${
                  isCurrentMonth ? "" : "outside"
                } ${dateKey === today ? "today" : ""} ${
                  assignment ? assignment.attendance_status : ""
                }`}
                onClick={() => onSelectDay(dateKey, assignment)}
              >
                <strong>{date.getDate()}</strong>

                <span>{labelFor(assignment)}</span>

                {assignment && (
                  <small>
                    {assignment.hours_worked}h · D{assignment.dog_grooming} / C
                    {assignment.cat_grooming}
                  </small>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StaffCalendar;
